
import lottie from '../assets/images/lottie/jvmp_intro.json';
import {
	onMounted,
	onUnmounted,
	Ref,
	ref,
} from 'vue';
import log from '@/global/log';
export default {
	setup() {
		let lottieShow = ref(false);
		let isMobile = ref();

		// Intersection Observer를 생성하고 콜백 함수를 정의합니다.
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						// div가 화면에 보이면 실행할 동작을 여기에 추가합니다.
						lottieShow.value = true;
					} else {
						// div가 화면에서 사라지면 실행할 동작을 여기에 추가합니다.
					}
				});
			}
		);

		const openEmail = () => {
			// 사용자의 이메일 주소와 이메일 제목, 본문 등을 설정합니다.
			const emailAddress = 'jvmp@thejoin.co.kr';
			const subject = '제목을 입력하세요';
			const body = '본문을 입력하세요';

			// "mailto" 링크를 생성합니다.
			const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(
				subject
			)}&body=${encodeURIComponent(body)}`;

			// "mailto" 링크를 클릭하여 사용자의 이메일 클라이언트를 엽니다.
			window.location.href = mailtoLink;
		};

		const openCall = () => {
			window.location.href = 'tel:02-6949-0335'; // 원하는 전화번호로 변경
		};

		onMounted(() => {
			const lottieEl = document.getElementById(
				'lottie'
			) as HTMLElement;
			log('has lottie', lottieEl);
			if (lottieEl) {
				observer.observe(lottieEl!);
			}
			const screenWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			if (screenWidth < 768) {
				isMobile.value = true;
			} else {
				isMobile.value = false;
			}

			window.addEventListener('resize', () => {
				const screenWidth =
					window.innerWidth ||
					document.documentElement.clientWidth ||
					document.body.clientWidth;
				if (screenWidth < 768) {
					isMobile.value = true;
				} else {
					isMobile.value = false;
				}
			});
		});
		const openNewWindow = () => {
			window.open(
				'https://youtu.be/to0_oUvPZBw?si=PP6OY2n-jU-srtQm',
				'_blank'
			);
		};
		return {
			isMobile,
			lottie,
			lottieShow,
			info: [
				{
					label: '보안이슈 원천적 차단',
					title:
						'업무 데이터를 물리적으로 분리하여<br> 강력한 정보보호 기능을 제공합니다.',
					subtitle:
						'보안이 필요한 구역 내에서 가상 업무공간을 이용하여 사용자 기기와 업무 데이터간의 통신이 원천적으로 차단되기 때문에 보안이슈를 최소화 할 수 있습니다.',
					img: require('../assets/images/jvmp/info1.png'),
				},
				{
					label: '하나의 APP',
					title:
						'스마트워크 개발비용과 운영비용을<br>획기적으로 절감할 수 있습니다.',
					subtitle:
						'가상 업무공간에서 사용할 Android용 앱 하나로 다양한 모바일 OS 기기에서 서비스가 가능하고 업무용 앱에 추가 보안 솔루션 도입이 필요하지 않게 됩니다.',
					img: require('../assets/images/jvmp/info2.png'),
				},
				{
					label: '통합중앙관리',
					title:
						'간소화되고 편리한 보안운영 업무<br>지원 기능을 제공합니다.',
					subtitle:
						'가상 업무공간 서버에 변경된 앱만 적용하면 별도의 배포작업 없이 모든 사용자에게 적용되고 관리콘솔을 통해 편리한 서비스 관리 업무를 지원합니다.',
					img: require('../assets/images/jvmp/info3.png'),
				},
			],
			openNewWindow,
			openEmail,
			openCall,
		};
	},
};
